<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import SportLiveTvError from '@/sport-live-tv/components/sport-live-tv-error.vue';
import SportLiveTvLoading from '@/sport-live-tv/components/sport-live-tv-loading.vue';
import SportLiveTvPlayer from '@/sport-live-tv/components/sport-live-tv-player.vue';
import SportLiveTvStreamError from '@/sport-live-tv/components/sport-live-tv-stream-error.vue';
import SportLiveTvStreamPicker from '@/sport-live-tv/components/sport-live-tv-stream-picker.vue';
import { useWatchSportLiveTv } from '@/sport-live-tv/composables/use-watch-sport-live-tv';
import { SPORT_LIVE_TV_ROUTE, SPORT_LIVE_TV_WATCH_VIEWS } from '@/sport-live-tv/constants';

const route = useRoute();
const router = useRouter();

const eventId = computed(() => Number(route.params.id));

const { view, title, subtitle, pickerSubtitle, isLive, sources, streamUrl, selectStream, handleStreamError, retryStream, refetch } = useWatchSportLiveTv(eventId);

const goToCatalog = () => router.push(SPORT_LIVE_TV_ROUTE);

const goBack = () => {
  if (window.history.state?.back) {
    router.back();
    return;
  }

  goToCatalog();
};
</script>

<template>
  <div class="watch-sport-live-tv-page">
    <SportLiveTvError v-if="view === SPORT_LIVE_TV_WATCH_VIEWS.error" @retry="refetch" />
    <SportLiveTvStreamError v-else-if="view === SPORT_LIVE_TV_WATCH_VIEWS.streamError" :title="title" @retry="retryStream" @back="goToCatalog" />
    <SportLiveTvStreamPicker v-else-if="view === SPORT_LIVE_TV_WATCH_VIEWS.streamPicker" :subtitle="pickerSubtitle" :sources="sources" @select="selectStream" />
    <SportLiveTvPlayer
      v-else-if="view === SPORT_LIVE_TV_WATCH_VIEWS.player"
      :event-id="eventId"
      :title="title"
      :subtitle="subtitle"
      :stream-url="streamUrl"
      :is-live="isLive"
      @back="goBack"
      @stream-error="handleStreamError"
    />
    <SportLiveTvLoading v-else />
  </div>
</template>

<style lang="scss" scoped>
.watch-sport-live-tv-page {
  min-height: 100vh;
  background-color: $black10;
}
</style>
